import { Dispatch } from 'redux';
import DomainController from '../controllers/DomainController';
import connectedPageHandler from '../errorHandlers/connected-page-handler';
import DomainModel from '../model/DomainModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import ConnectedPageCRUDActions from './ConnectedPageCRUDActions';
import CrudActionContainer from './CrudActionContainer';

class DomainCRUDActions extends CrudActionContainer {
  constructor() {
    super('DOMAIN');
  }

  retrieveAll(pageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      ConnectedPageCRUDActions.clearErrorStatus(dispatch);
      try {
        const response = await DomainController.getAll(pageId);
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        if (e.status === 500) {
          dispatch(this.unbusy());
          dispatch(
            this.retrieved({
              connectedPageId: pageId,
              unavailable: true,
              domainList: [],
            }),
          );
          return;
        }
        await connectedPageHandler(dispatch)(e);
      }
    };
  }

  update(domain: DomainModel) {
    return async (dispatch: Dispatch<StoreState>) => {
      if (!domain.connectedPageId) {
        return;
      }
      ConnectedPageCRUDActions.clearErrorStatus(dispatch);
      try {
        dispatch(this.busy(this.updateAction));
        await DomainController.putDomain(domain.connectedPageId, domain);
        dispatch(this.updateLocal(domain));
      } catch (e) {
        dispatch(this.unbusy());
        await connectedPageHandler(dispatch)(e);
      }
    };
  }
}

const domainCRUDActions = new DomainCRUDActions();
export default domainCRUDActions;

export const useDomainCRUDActions = getActionHookBuilder(domainCRUDActions, [
  'retrieveAll',
  'update',
]);
